var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { generateReducer } from "../generators/generator.reducer";
import { markAllAsReadStart, markAllAsReadSucceeded, markAllAsReadFailed, } from "./card.actions";
import { GENERATOR_PARAMS } from "./card.constants";
var getExtraDefaultState = function () { return ({
    cards: {
        isPending: false,
        error: undefined,
    },
}); };
var _reducer = generateReducer(GENERATOR_PARAMS, getExtraDefaultState);
var reducer = _reducer;
reducer.on(markAllAsReadStart.type, function (state, _) {
    return __assign(__assign({}, state), { cards: __assign(__assign({}, state.cards), { isPending: true, error: undefined }) });
});
reducer.on(markAllAsReadSucceeded.type, function (state, _) {
    return __assign(__assign({}, state), { cards: __assign(__assign({}, state.cards), { isPending: false, error: undefined }) });
});
reducer.on(markAllAsReadFailed.type, function (state, payload) {
    return __assign(__assign({}, state), { cards: __assign(__assign({}, state.cards), { isPending: false, error: payload.error }) });
});
// eslint-disable-next-line import/no-default-export
export default reducer;
